import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { SeFeApiService } from 'se-fe-api'
import { Ethnicity } from 'se-resource-types/dist/lib/UserService'

@Injectable({
  providedIn: 'root'
})
export class EthnicityService {
  public endpoint = 'ethnicities'

  constructor(private api: SeFeApiService) {
    // noop
  }

  public allEthnicities(): Observable<Ethnicity[]> {
    return this.api.get(`${this.endpoint}`)
      .pipe(first())
      .pipe(map(response => response.result as Ethnicity[]))
  }
}
